var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 395,
    viewBox: "0 0 300 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.011 219.521C300.28 216.769 300.641 212.91 298.923 209.784L251.822 124.077C250.294 121.295 247.374 119.567 244.202 119.567H55.798C52.6269 119.567 49.7069 121.295 48.1785 124.077L1.07735 209.784C-0.641364 212.91 -0.27936 216.769 1.98943 219.521L143.293 390.935C144.945 392.94 147.405 394.1 150 394.1C152.595 394.1 155.056 392.94 156.708 390.935L298.011 219.521ZM203.728 222.685H272.851L169.167 348.464L203.728 222.685ZM150 352.57L114.31 222.685H185.689L150 352.57ZM117.609 205.274L150 146.335L182.391 205.276H117.609V205.274ZM164.71 136.978H229.492L197.101 195.919L164.71 136.978ZM102.899 195.919L70.5087 136.978H135.291L102.899 195.919ZM88.1895 205.274H23.4065L55.798 146.334L88.1895 205.274ZM96.271 222.685L130.831 348.463L27.1484 222.685H96.271ZM276.593 205.274H211.811L244.201 146.334L276.593 205.274Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.303 8.80514V48.0704C141.303 52.878 145.197 56.7759 150 56.7759C154.803 56.7759 158.697 52.878 158.697 48.0704V8.80514C158.697 3.99751 154.803 0.0996094 150 0.0996094C145.197 0.0996094 141.303 3.99751 141.303 8.80514Z",
    fill: "#006CB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8301 28.04C41.6708 30.4438 40.2456 35.7673 42.647 39.9318L62.2584 73.9367C63.8695 76.729 66.7928 78.2905 69.7986 78.2905C71.2749 78.2905 72.7697 77.914 74.1394 77.1229C78.2987 74.7191 79.7239 69.3957 77.3225 65.2312L57.71 31.2263C55.3086 27.0628 49.9904 25.6384 45.8301 28.04Z",
    fill: "#006CB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242.29 31.2263L222.676 65.2312C220.275 69.3946 221.7 74.718 225.858 77.1229C227.228 77.914 228.724 78.2905 230.199 78.2905C233.205 78.2905 236.128 76.729 237.739 73.9367L257.353 39.9318C259.754 35.7684 258.329 30.4438 254.17 28.04C250.012 25.6351 244.691 27.0617 242.29 31.2263Z",
    fill: "#006CB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCore);
export default __webpack_public_path__ + "static/media/core.a476fb561e86bdf13d549ebcf1969cb7.svg";
export { ForwardRef as ReactComponent };